import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/ProductsPage.css';

const ProductsPage = () => {
  const { t } = useLanguage();
  
  // Generate product data, excluding products 1, 2, and 14
  const allProductIds = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  const products = allProductIds.map((productId) => ({
    id: productId,
    image: `/images/product-${String(productId).padStart(2, '0')}.jpg`
  }));

  return (
    <div className="products-page">
      <section className="products-hero">
        <div className="container">
          <h1>{t('products.title')}</h1>
          <p className="lead">{t('products.lead')}</p>
        </div>
      </section>

      <section className="products-grid-section">
        <div className="container">
          <div className="products-grid">
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <div className="product-image-container">
                  <img
                    src={product.image}
                    alt={`Product ${product.id}`}
                    className="product-image"
                    onError={(e) => {
                      e.target.src = '/images/product-03.jpg'; // Fallback image
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
